// extracted by mini-css-extract-plugin
module.exports = {"contentBodyWrapper":"hnFmhuXF","contentBody":"KLcGo9L7","noNewsFoundWrapper":"wDKxZGuK"};